// For browserify Phaser
(function () {
  /* eslint-disable global-require */
  window.p2 = require('p2');
  window.PIXI = require('pixi');
  window.Phaser = require('phaser');
  /* eslint-enable global-require */
}());

require('babel-polyfill');
const Phaser = require('phaser');
const URI = require('uri.js');
const _ = require('lodash');

// States
// State Pre Loader
class StatePreLoader extends Phaser.State {
  preload() {
    this.stage.backgroundColor = '#FFFFFF';
    this.load.image('imageTitle', 'assets/images/title.png');
    this.load.image('buttonStart', 'assets/images/btn_start.png');
    this.load.json('assetsConfig', 'assets/json/asset.json');
  }
  create() {
    // Game オブジェクトができないと諸々が設定できないので，最初の State で設定する
    // Canvas
    Phaser.Canvas.setTouchAction(this.game.canvas, 'auto');
    if (!this.game.device.isAndroidStockBrowser()) this.input.touch.preventDefault = false;

    // Scale
    this.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;

    this.state.start('StateLoader');
  }
}
// State Loader
class StateLoader extends Phaser.State {
  create() {
    // Loading Screen
    this.add.image(
      this.world.centerX - Math.floor(this.cache.getImage('imageTitle').width / 2),
      this.world.centerY - Math.floor(this.cache.getImage('imageTitle').height / 2),
      'imageTitle'
    );

    // Loading Assets
    const assets = this.cache.getJSON('assetsConfig');
    assets.images.forEach(asset => this.load.image(asset.name, asset.path));
    assets.jsons.forEach(asset => this.load.json(asset.name, asset.path));
    assets.sounds.forEach(asset => this.load.audio(asset.name, asset.path));
    assets.atlas.forEach(asset => this.load.atlas(asset.name, asset.path, asset.json));
    this.load.onLoadComplete.addOnce(() => {
      const button = this.add.button(
        this.world.centerX - Math.floor(this.cache.getImage('buttonStart').width / 2),
        (this.world.centerY - Math.floor(this.cache.getImage('buttonStart').height / 2)) + 235,
        'buttonStart'
      );
      button.onInputUp.addOnce(() => {
        this.game.logger.log({
          eventId: 'button.tapped',
          screenId: 'loading',
          stuff: {
            button_name: 'start',
          },
        });
        this.state.start('StateMode');
      });
    });
    this.load.start();
  }
}
// Quiz
class QuizController {
  constructor(param) {
    this.game = param.game;
    this.modeName = param.modeName;
    this.config = _.cloneDeep(this.game.cache.getJSON('quizConfig'));

    this.quizList = _.clone(this.config[param.modeName]);
    if (!this.game.gameInternalOption.isDev) this.quizList = _.shuffle(this.quizList);
  }
  startQuiz() {
    this.game.state.start('StateQuiz', true, false, { quizController: this });
  }
  nextQuiz() {
    this.quizList.shift();
    this.game.state.start('StateQuiz', true, false, { quizController: this });
  }
  closeQuiz() {
    const state = this.quizList.length > 1 ? 'StateQuizClosing' : 'StateModeClosing';
    this.game.state.start(state, true, false, { quizController: this });
  }
  getCurrentQuizName() {
    let quizName = this.quizList[0].name;
    quizName = quizName.charAt(0).toUpperCase() + quizName.slice(1);
    return quizName;
  }
  getCurrentTalkGuideList() {
    return this.quizList[0].guide;
  }
  getFpsList() {
    return this.quizList[0].fps;
  }
  getSoundList() {
    return this.quizList[0].sound;
  }
}
// Mode Menu
class StateMode extends Phaser.State {
  init() {
    this.loader = new Phaser.Loader(this.game);
    this.wanwanVoice = null;
    this.bgm = null;
  }
  create() {
    this.bgm = this.add.sound('bgmOpening', 0.8, true, true);
    this.bgm.onDecoded.add(() => this.bgm.play());
    this.tapSound = this.add.audio('soundModeTap');

    this.add.image(
      this.world.centerX - Math.floor(this.cache.getImage('backgroundModeSelect').width / 2),
      this.world.centerY - Math.floor(this.cache.getImage('backgroundModeSelect').height / 2),
      'backgroundModeSelect'
    );
    const wanwan = this.add.sprite(
      this.world.centerX
        - Math.floor(
          this.cache.getFrameData('animationWanwanModeSelectIn').getFrame(0).width / 2
        ),
      0,
      'animationWanwanModeSelectIn'
    );
    const animationScreenIn = wanwan.animations.add('screenin', null, 15, false);
    animationScreenIn.onComplete.add(() => {
      const wanwanLoop = this.add.sprite(
        this.world.centerX
          - Math.floor(
            this.cache.getFrameData('animationWanwanModeSelectLoop').getFrame(0).width / 2
          ),
        340,
        'animationWanwanModeSelectLoop'
      );
      wanwanLoop.inputEnabled = true;
      const sounds = [
        'voiceWanwanTapModeSelect01',
        'voiceWanwanTapModeSelect02',
        'voiceWanwanTapModeSelect03',
        'voiceWanwanTapModeSelect04',
      ].map(key => this.add.audio(key));
      wanwanLoop.events.onInputDown.add(() => {
        if (this.wanwanVoice && this.wanwanVoice.isPlaying) return;
        this.wanwanVoice = _.shuffle(sounds)[0];
        this.wanwanVoice.play();
        this.game.logger.log({
          eventId: 'wanwan.tapped',
          screenId: 'modeselection',
        });
      });

      wanwan.destroy();
      wanwanLoop.animations.add('loop', null, 15, true);
      wanwanLoop.play('loop');
      this.wanwanVoice = this.add.audio('voiceWanwanModeSelect');
      this.wanwanVoice.play();
    });
    wanwan.play('screenin');

    // モード選択のボタンをセンターから配置する
    const marginSideButton = 10;
    const centerButton = this.add.button(
      (this.world.centerX - Math.floor(this.cache.getImage('buttonPotupotu').width / 2)) + 20,
      (this.world.centerY - Math.floor(this.cache.getImage('buttonPotupotu').height / 2)) - 160,
      'buttonPotupotu'
    );
    centerButton.onInputUp.addOnce(() => this.assetLoader(centerButton));
    const rightButton = this.add.button(
      (centerButton.x - this.cache.getImage('buttonMogomogo').width) - marginSideButton,
      this.world.centerY - Math.floor(this.cache.getImage('buttonMogomogo').height / 2),
      'buttonMogomogo'
    );
    rightButton.onInputUp.addOnce(() => this.assetLoader(rightButton));
    const leftButton = this.add.button(
      (centerButton.x + centerButton.width) + (marginSideButton - 40),
      this.world.centerY - Math.floor(this.cache.getImage('buttonSurasura').height / 2),
      'buttonSurasura'
    );
    leftButton.onInputUp.addOnce(() => this.assetLoader(leftButton));
  }
  assetLoader(button) {
    if (this.loader.isLoading || this.loader.hasLoaded) return;

    this.tapSound.play();

    const mode = button.key.replace(/^button/i, '').toLowerCase();
    const assets = this.cache.getJSON('assetsConfig').mode[mode];
    assets.sounds.forEach(
      asset => this.loader.audio(asset.name, asset.path)
    );
    assets.atlas.forEach(
      asset => this.loader.atlas(asset.name, asset.path, asset.json)
    );
    this.loader.onLoadStart.addOnce(() => {
      const animation = this.cache.getFrameData('animationLoading');
      const animationLoading = this.add.sprite(
        this.game.canvas.width - animation.getFrame(0).width - 16,
        this.game.canvas.height - animation.getFrame(0).height - 16,
        'animationLoading'
      );
      animationLoading.animations.add('loading', null, 30, true);
      animationLoading.play('loading');
    });
    this.loader.onLoadComplete.addOnce(() => {
      const q = new QuizController({
        modeName: mode,
        game: this.game,
      });
      // Android ブラウザは即 BGM 終了．それ以外はフェードアウトしてクイズを開始する
      // ref. https://github.com/smarteducationltd/web.peekaboo/issues/236
      if (this.game.device.isAndroidStockBrowser()) {
        this.bgm.stop();
        q.startQuiz();
      } else {
        this.bgm.onFadeComplete.addOnce(() => q.startQuiz());
        this.bgm.fadeOut(2000);
      }
    });
    this.loader.start();
    this.game.logger.log({
      eventId: 'button.tapped',
      screenId: 'modeselection',
      stuff: {
        mode_name: mode,
      },
    });
  }
}
// Quiz
class StateQuiz extends Phaser.State {
  init(param) {
    this.quizController = param.quizController;
    this.silhouetteNo = 1;
    this.silhouetteContainer = null;
    this.timer = null;
    this.lock = false;
  }
  create() {
    if (!this.game.bgm) {
      this.game.bgm = this.add.sound('bgmPlaying', 0.5, true, true);
      this.game.bgm.onDecoded.add(() => this.game.bgm.play());
    }

    const background = this.add.image(
      this.world.centerX - Math.floor(this.cache.getImage('backgroundQuiz').width / 2),
      this.world.centerY - Math.floor(this.cache.getImage('backgroundQuiz').height / 2),
      'backgroundQuiz'
    );
    this.add.image(
      this.world.centerX - Math.floor(this.cache.getImage('canvas').width / 2),
      (this.world.centerY - Math.floor(this.cache.getImage('canvas').height / 2)) - 56,
      'canvas'
    );
    this.sound = this.add.audio('soundTap');
    this.guide = this.add.tileSprite(
      background.x,
      (background.y + this.cache.getImage('backgroundQuiz').height)
        - this.cache.getImage('patternGuide').height,
      this.cache.getImage('backgroundQuiz').width,
      this.cache.getImage('patternGuide').height,
      'patternGuide'
    );
    // シルエットを配置する
    this.silhouetteContainer = this.add.group();
    this.addSilhouette();
  }
  addSilhouette() {
    const silhouetteName = this.getSilhouetteName();
    this.silhouetteContainer.removeAll();
    // シルエット別のトークガイドを表示する
    this.getTalkGuideText().split('\n').forEach((text, i) => {
      const t = this.add.text(
        this.guide.x + 142,
        (this.guide.y + 22) + (i * 32),
        text,
        { fill: '#FFFFFF', font: 'Noto Sans Japanese', fontSize: 28 }
      );
      this.silhouetteContainer.add(t);
    });

    // シルエットを出す
    const silhouette = this.add.sprite(
      this.world.centerX,
      this.world.centerY - 60,
      silhouetteName
    );
    silhouette.anchor.setTo(0.5, 0.5);
    silhouette.animations.add('tap', null, this.getSilhouetteFps(), false);
    this.silhouetteContainer.add(silhouette);
    silhouette.inputEnabled = true;
    silhouette.events.onInputDown.add(() => {
      this.sound.play();

      if (this.lock) {
        silhouette.animations.play('tap');
        return;
      }
      this.lock = !this.game.gameInternalOption.isDev;
      this.game.logger.log({
        eventId: 'silhouette.tapped',
        screenId: 'quiz',
        stuff: {
          mode_name: this.quizController.modeName,
          quiz_name: this.quizController.getCurrentQuizName().toLowerCase(),
          silhouette_no: this.silhouetteNo,
        },
      });

      // シルエット切り替えのアニメーション
      const scaleAnimation = this.add.tween(silhouette.scale);
      scaleAnimation.to({ x: 0.85, y: 0.85 }, 667, Phaser.Easing.Linear.None, false);
      const rotateAnimation = this.add.tween(silhouette);
      rotateAnimation.to({ angle: 5 }, 667, Phaser.Easing.Linear.None, false);
      scaleAnimation.onComplete.add(() => { // tween.chain() を使うともう少しわかりやすく書けそう
        silhouette.visible = false;

        const nextSilhouette = this.add.sprite(
          this.game.world.centerX,
          this.game.world.centerY - 60,
          this.getNextSilhouetteName()
        );
        this.silhouetteContainer.add(nextSilhouette);
        nextSilhouette.anchor.setTo(0.5, 0.5);
        const nextScaleAnimation = this.add.tween(nextSilhouette.scale);
        nextScaleAnimation.to({ x: 2.0, y: 2.0 }, 133, Phaser.Easing.Linear.None, false);
        nextScaleAnimation.to({ x: 0.9, y: 0.9 }, 133, Phaser.Easing.Linear.None, false);
        nextScaleAnimation.to({ x: 1.0, y: 1.0 }, 67, Phaser.Easing.Linear.None, false);
        const nextRotateAnimation = this.add.tween(nextSilhouette);
        nextRotateAnimation.to({ angle: -15 }, 133, Phaser.Easing.Linear.None, false);
        nextRotateAnimation.to({ angle: 5 }, 133, Phaser.Easing.Linear.None, false);
        nextRotateAnimation.to({ angle: 0 }, 67, Phaser.Easing.Linear.None, false);
        nextScaleAnimation.onComplete.add(() => {
          // シルエット切り替えのアニメーション終了
          this.silhouetteNo++;
          if (this.silhouetteNo > 4) {
            // クイズ終了スクリーンへ
            this.quizController.closeQuiz();
            return;
          }
          this.addSilhouette();
        });
        nextScaleAnimation.start();
        nextRotateAnimation.start();
      });
      scaleAnimation.start();
      rotateAnimation.start();
    });

    // シルエットロックをする
    // 5秒間シルエットが先に進まないようにする
    this.lock = !this.game.gameInternalOption.isDev;
    this.timer = this.time.create(false);
    this.timer.add(5000, () => { // 5秒後にシルエットスイッチのロックを解除する
      this.timer.stop();
      this.timer.destroy();
      this.lock = false;
    });
    this.timer.start();
  }
  getSilhouetteName() {
    const quizName = this.quizController.getCurrentQuizName();
    const silhouetteNo = `00${this.silhouetteNo}`.slice(-2);
    return `silhouette${quizName}${silhouetteNo}`;
  }
  getNextSilhouetteName() {
    const quizName = this.quizController.getCurrentQuizName();
    const i = this.silhouetteNo + 1;
    const silhouetteNo = `00${i}`.slice(-2);
    return `silhouette${quizName}${silhouetteNo}`;
  }
  getSilhouetteFps() {
    let fps = 15; // 初期値
    const fpsList = this.quizController.getFpsList();
    if (fpsList) {
      fps = fpsList[this.silhouetteNo - 1];
    }
    return fps;
  }
  getTalkGuideText() {
    const talkGuideList = this.quizController.getCurrentTalkGuideList();
    return talkGuideList[this.silhouetteNo - 1];
  }
}
class StateClosingBase extends Phaser.State {
  init(param) {
    this.quizController = param.quizController;
    this.wanwanVoice = null;
    this.timer = null;
    this.lock = false;
  }
  create() {
    // 背景
    const background = this.add.image(
      this.world.centerX - Math.floor(this.cache.getImage('backgroundQuiz').width / 2),
      this.world.centerY - Math.floor(this.cache.getImage('backgroundQuiz').height / 2),
      'backgroundQuiz'
    );
    this.add.image(
      this.world.centerX - Math.floor(this.cache.getImage('canvas').width / 2),
      (this.world.centerY - Math.floor(this.cache.getImage('canvas').height / 2)) - 56,
      'canvas'
    );

    // 次へ進むボタンを置く
    const quizName = this.quizController.getCurrentQuizName();
    this.buttonTapSound = this.add.audio('soundTap');
    this.nextButton = this.add.button(
      this.world.centerX + 320,
      this.world.centerY - 310,
      'buttonNextSilhouette'
    );
    this.nextButton.visible = false;
    this.nextButton.onInputUp.addOnce(() => {
      this.buttonTapSound.play();
      this.game.logger.log({
        eventId: 'button.tapped',
        screenId: 'quiz',
        stuff: {
          button_name: 'next',
          mode_name: this.quizController.modeName,
          quiz_name: quizName.toLowerCase(),
          silhouette_no: 5,
        },
      });
    });

    // 最後のシルエットを配置する
    const sound = this.add.audio(this.getSilhouetteTapSound());
    const silhouetteName = `silhouette${quizName}05`;
    const silhouette = this.add.sprite(
      this.world.centerX,
      this.world.centerY - 60,
      silhouetteName
    );
    silhouette.anchor.setTo(0.5, 0.5);
    const fpsList = this.quizController.getFpsList();
    silhouette.animations.add('tap', null, (function () {
      let fps = 15;
      if (fpsList) fps = _.last(fpsList);
      return fps;
    }()), false);
    silhouette.inputEnabled = true;
    silhouette.events.onInputDown.add(() => {
      sound.play();
      silhouette.animations.play('tap');

      if (this.lock) return;
      if (this.nextButton.visible) return;

      this.game.logger.log({
        eventId: 'silhouette.tapped',
        screenId: 'quiz',
        stuff: {
          mode_name: this.quizController.modeName,
          quiz_name: quizName.toLowerCase(),
          silhouette_no: 5,
        },
      });
      this.nextButton.visible = true;
      this.silhouetteContainer.removeAll();
      this.add.text(
        this.world.centerX - 320,
        this.guide.y + 22,
        '矢印ボタンをタップで次のシルエットで遊べます。',
        { fill: '#FFFFFF', font: 'Noto Sans Japanese', fontSize: 28 }
      );
    });

    // ワンワンを配置する
    const wanwan = this.add.sprite(
      this.world.centerX + 180,
      this.world.centerY - 150,
      'animationWanwanQuizIn'
    );
    const animationScreenIn = wanwan.animations.add('screenin', null, 15, false);
    const wanwanLoop = this.add.sprite(
      this.world.centerX + 180,
      this.world.centerY - 20,
      `animationWanwanQuizLoop0${Math.floor(Math.random() * 4) + 1}`
    );
    wanwanLoop.visible = false;
    wanwanLoop.inputEnabled = true;
    wanwanLoop.animations.add('loop', null, 15, true);
    animationScreenIn.onComplete.add(() => {
      const sounds = [
        'voiceWanwanTapQuiz01',
        'voiceWanwanTapQuiz02',
        'voiceWanwanTapQuiz03',
      ].map(key => this.add.audio(key));
      wanwanLoop.events.onInputDown.add(() => {
        if (this.wanwanVoice && this.wanwanVoice.isPlaying) return;
        this.wanwanVoice = _.shuffle(sounds)[0];
        this.wanwanVoice.play();

        this.game.logger.log({
          eventId: 'wanwan.tapped',
          screenId: 'quiz',
          stuff: {
            mode_name: this.quizController.modeName,
            quiz_name: quizName.toLowerCase(),
            silhouette_no: 5,
          },
        });
      });

      wanwan.destroy();
      wanwanLoop.visible = true;
      wanwanLoop.play('loop');
    });
    wanwan.play('screenin');

    // トークガイドを配置する
    this.guide = this.add.tileSprite(
      background.x,
      (background.y + this.cache.getImage('backgroundQuiz').height)
        - this.cache.getImage('patternGuide').height,
      this.cache.getImage('backgroundQuiz').width,
      this.cache.getImage('patternGuide').height,
      'patternGuide'
    );
    this.silhouetteContainer = this.add.group();
    _.last(this.quizController.getCurrentTalkGuideList()).split('\n').forEach((text, i) => {
      const t = this.add.text(
        this.guide.x + 142,
        (this.guide.y + 22) + (i * 32),
        text,
        { fill: '#FFFFFF', font: 'Noto Sans Japanese', fontSize: 28 }
      );
      this.silhouetteContainer.add(t);
    });

    // 5秒間次のクイズに進まないようにする
    this.lock = !this.game.gameInternalOption.isDev;
    this.timer = this.time.create(false);
    this.timer.add(5000, () => {
      this.timer.stop();
      this.timer.destroy();
      this.lock = false;
    });
    this.timer.start();
  }
  getSilhouetteTapSound() {
    let sound = 'soundPuyon01';
    const tapList = this.quizController.getSoundList();
    if (tapList) {
      sound = _.shuffle(tapList)[0];
    }
    return sound;
  }
}
class StateQuizClosing extends StateClosingBase {
  create() {
    super.create();
    // 次のクイズに進む
    this.nextButton.onInputUp.addOnce(() => this.quizController.nextQuiz());
  }
}
class StateModeClosing extends StateClosingBase {
  init(param) {
    super.init(param);
    this.modal = null;
  }
  create() {
    super.create();
    // 次のクイズに進む
    this.nextButton.onInputUp.addOnce(() => { this.modal.visible = true; });

    // Modal
    this.modal = this.add.group();
    this.modal.inputEnableChildren = true;
    this.modal.visible = false;
    this.modal.add(
      this.add.tileSprite(0, 0, this.game.canvas.width, this.game.canvas.height, 'patternModal')
    );
    // 同じモードでもう一度楽しむボタンを配置する
    const sameButtonImage = this.cache.getImage('buttonSameMode');
    const sameButton = this.add.button(
      this.world.centerX - Math.floor(sameButtonImage.width / 2) - 180,
      this.world.centerY - Math.floor(sameButtonImage.height / 2) - 60,
      'buttonSameMode'
    );
    sameButton.setDownSound(this.buttonTapSound);
    sameButton.onInputUp.addOnce(() => {
      this.game.logger.log({
        eventId: 'button.tapped',
        screenId: 'quiz',
        stuff: {
          button_name: 'samemode',
          mode_name: this.quizController.modeName,
          quiz_name: this.quizController.getCurrentQuizName().toLowerCase(),
          silhouette_no: 5,
        },
      });
      const q = new QuizController({
        modeName: this.quizController.modeName,
        game: this.game,
      });
      q.startQuiz();
    });
    this.modal.add(sameButton);
    // 別のモードで楽しむボタンを配置する
    const differentButtonImage = this.cache.getImage('buttonDifferentMode');
    const differentButton = this.add.button(
      (this.world.centerX - Math.floor(differentButtonImage.width / 2)) + 180,
      (this.world.centerY - Math.floor(differentButtonImage.height / 2)) - 60,
      'buttonDifferentMode'
    );
    differentButton.setDownSound(this.buttonTapSound);
    differentButton.onInputUp.addOnce(() => {
      this.game.logger.log({
        eventId: 'button.tapped',
        screenId: 'quiz',
        stuff: {
          button_name: 'differentmode',
          mode_name: this.quizController.modeName,
          quiz_name: this.quizController.getCurrentQuizName().toLowerCase(),
          silhouette_no: 5,
        },
      });
      this.game.bgm.stop();
      this.state.start('StateMode', true, false);
    });
    this.modal.add(differentButton);
    // 終わりボタンを配置する
    const endButtonImage = this.cache.getImage('buttonEnd');
    const endButton = this.add.button(
      this.world.centerX - Math.floor(endButtonImage.width / 2),
      (this.world.centerY - Math.floor(endButtonImage.height / 2)) + 60,
      'buttonEnd'
    );
    endButton.setDownSound(this.buttonTapSound);
    endButton.onInputUp.addOnce(() => {
      this.game.logger.log({
        eventId: 'button.tapped',
        screenId: 'quiz',
        stuff: {
          button_name: 'stopgame',
          mode_name: this.quizController.modeName,
          quiz_name: this.quizController.getCurrentQuizName().toLowerCase(),
          silhouette_no: 5,
        },
      });
      location.href = 'http://www.sukusuku.com';
    });
    this.modal.add(endButton);
  }
}

// Logger
class Logger {
  constructor(config) {
  }
  log(param) {
    console.log(JSON.stringify(param));
  }
}

// Game
class Peekaboo extends Phaser.Game {
  constructor(window, config) {
    super(
      Math.min(
        config.maxCanvasWidth,
        (config.canvasHeight * window.innerWidth) / window.innerHeight
      ),
      config.canvasHeight,
      Phaser.AUTO,
      config.containerName
    );
    this.gameInternalOption = {
      isDev: config.isDev,
      isStudy: config.isStudy,
    };
    this.logger = new Logger({
      isDev: config.isDev,
      isStudy: config.isStudy,
    });

    this.state.add('StatePreLoader', StatePreLoader);
    this.state.add('StateLoader', StateLoader);
    this.state.add('StateMode', StateMode);
    this.state.add('StateQuiz', StateQuiz);
    this.state.add('StateQuizClosing', StateQuizClosing);
    this.state.add('StateModeClosing', StateModeClosing);

    this.state.start('StatePreLoader');
  }
}

// Bootstrap Game
// スマートデバイスの時はランドスケープ(横長)じゃないとゲームを起動しないようにする
class GameLoader {
  constructor(window, config) {
    this.window = window;
    this.isStudy = config.isStudy;
    const query = new URI(window.location.search).query;
    this.isDev = query.dev;

    this.game = null;
  }
  load() {
    if (
      typeof this.window.orientation === 'undefined' ||
      this.window.innerWidth > this.window.innerHeight) {
      if (!this.game) {
        // iPhone 5s のサイズをメインターゲットに canvas を作る
        this.game = new Peekaboo(this.window, {
          containerName: 'player-container',
          canvasHeight: 640 + 1, // iPhone 5だと高さがぴったりだとメニューバーが表示されてしまう(バグ？)ので 1px 足しておく
          maxCanvasWidth: 1136,
          isStudy: this.isStudy,
          isDev: this.isDev,
        });
      }
      this.showGame();
    } else {
      this.hideGame();
    }
  }
  showGame() {
    this.window.document.querySelector('#player-container').style.display = 'block';
    this.window.document.querySelector('#orientation-messeage').style.display = 'none';
    if (this.game && this.game.bgm && this.game.bgm.paused) this.game.bgm.resume();
  }
  hideGame() {
    this.window.document.querySelector('#player-container').style.display = 'none';
    this.window.document.querySelector('#orientation-messeage').style.display = 'block';
    if (this.game && this.game.bgm && this.game.bgm.isPlaying) this.game.bgm.pause();
  }
  checkUid() {
    if (
      this.isDev ||
      this.window.location.hostname === 'staging-peekaboo.netlify.com' ||
      this.window.location.hostname === 'localhost'
    ) {
      return new Promise(resolve => resolve(true));
    }

    return this.makeRequest({
      method: 'GET',
      url: 'user.php'
    });
  }
  makeRequest(opts) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open(opts.method, opts.url);
      xhr.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          resolve(xhr.response);
        } else {
          reject({
            status: this.status,
            statusText: xhr.statusText,
          });
        }
      };
      xhr.onerror = function () {
        reject({
          status: this.status,
          statusText: xhr.statusText,
        });
      };
      xhr.send();
    });
  }
}

const gameLoader = new GameLoader(window, {
  isStudy: false, // 共同研究実施中なのかどうか
});
// ログイン済みであればゲームを起動し，そうでない時はログインページへ
gameLoader.checkUid().then(() => {
  window.addEventListener('resize', () => gameLoader.load(), false);
  gameLoader.load();
}).catch(() => {
  location.href = "/sso/account/login?href=/word_game/game.html";
});
